<template>
  <NavBar :notifications="notifications" />
  <div v-for="(notification, index) in notifications" :key="index">
    <NotificationItem :userName="notification.name" :profilePic="notification.profilePicture"
      :action="notification.action" :actionName="notification.actionName" :time="notification.notificationTime"
      :notificationPic="notification.notificationPicture" :message="notification.message"
      :isReaded="notification.isReaded" />
  </div>

</template>

<script>
import NavBar from './components/NavBar.vue'
import NotificationItem from './components/NotificationItem.vue';
export default {
  name: 'App',
  components: {
    NavBar,
    NotificationItem
  },
  data() {
    return {
      notifications: [
        {
          name: 'Mark Webber',
          profilePicture: './assets/images/avatar-mark-webber.webp',
          action: 'reacted to your recent post',
          actionName: 'My first tournament today!',
          notificationTime: '1m ago',
          isReaded: false,
          notificationPicture: '',
          message: ""
        },
        {
          name: 'Angela Gray',
          profilePicture: './assets/images/avatar-angela-gray.webp',
          action: 'followed you',
          actionName: '',
          notificationTime: '5m ago',
          isReaded: false,
          notificationPicture: '',
          message: ""
        },
        {
          name: 'Jacob Thompson',
          profilePicture: './assets/images/avatar-jacob-thompson.webp',
          action: 'has joined your group',
          actionName: 'Chess Club',
          notificationTime: '1 day ago',
          isReaded: false,
          notificationPicture: '',
          message: ""
        },
        {
          name: 'Rizky Hasanuddin',
          profilePicture: './assets/images/avatar-rizky-hasanuddin.webp',
          action: 'sent you a private message',
          actionName: '',
          notificationTime: '5 days ago',
          isReaded: true,
          notificationPicture: '',
          message: "Hello, thanks for setting up the Chess Club. I've been a member for a few weeks now and I'm already having lots of fun and improving my game."
        },
        {
          name: 'Kimberly Smith',
          profilePicture: './assets/images/avatar-kimberly-smith.webp',
          action: 'commented on your picture',
          actionName: '',
          notificationTime: '1 week ago',
          isReaded: true,
          notificationPicture: './assets/images/image-chess.webp',
          message: ""
        },
        {
          name: 'Nathan Peterson',
          profilePicture: './assets/images/avatar-nathan-peterson.webp',
          action: 'reacted to your recent post',
          actionName: '5 end-game strategies to increase your win rate',
          notificationTime: '2 weeks ago',
          isReaded: true,
          notificationPicture: '',
          message: ""
        },
        {
          name: 'Anna Kim',
          profilePicture: './assets/images/avatar-anna-kim.webp',
          action: 'left the group',
          actionName: 'Chess Club',
          notificationTime: '2 weeks ago',
          isReaded: true,
          notificationPicture: '',
          message: ""
        }
      ]
    }
  }
}
</script>

<style>

@media screen and (min-width: 360px) {
  body {
    padding-top: 10px;
    padding-left: 0px;
    padding-right: 0px; 
  }

}

@media screen and (min-width: 800px) {
  body {
    padding-top: 30px;
    padding-left: 50px;
    padding-right: 50px; 
  }

}

@media screen and (min-width: 1200px) {
  body {
  padding-top: 30px;
  padding-bottom: 80px;
  padding-left: 300px;
  padding-right: 300px; 
}
}
</style>
